import React, {Suspense} from 'react';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';


import * as i18nUtils from '../../utils/i18nUtils';

// importing additional validations upfront
import '../../services/FormService/validations';

import config from '../../config';
import configureStore from '../../store/configureStore';

import Analytics from '../contexts/Analytics/Analytics';
import AuthProvider from '../contexts/Auth/AuthProvider/AuthProvider';
import LoadingIndicator from '../global/LoadingIndicator';
import PrivateRoot from './PrivateRoot';
import PublicRoot from './PublicRoot';
import ScrollToTop from '../contexts/ScrollToTop';

import {AuthPages} from '../modules/Auth';
import {DispatchOnRouteChange} from '../contexts/Navigation';
import {ErrorBoundary} from '../error';
import {FeedbackButton} from '../global/Feedback';
import {I18nProvider} from '../contexts/I18n';
import {StaticPages} from '../modules/Static';
import {NewsletterPages} from '../modules/Newsletter';


const initialLocaleTag = i18nUtils.detectBrowserLocaleTag();
const store = configureStore();


const Root = () => {

    return (
        <Provider store={store}>

            <BrowserRouter>

                <ErrorBoundary>

                    <AuthProvider>

                        <I18nProvider
                            defaultLocaleTag={config.locale.defaultLocaleTag}
                            localeTag={initialLocaleTag}
                        >

                            <Analytics>

                                <Suspense fallback={<LoadingIndicator isViewport={true}/>}>

                                    <DispatchOnRouteChange/>
                                    <ScrollToTop/>

                                    <StaticPages/>

                                    <AuthPages/>

                                    <PublicRoot/>

                                    <PrivateRoot/>

                                    <FeedbackButton/>

                                    <NewsletterPages/>

                                </Suspense>

                            </Analytics>

                        </I18nProvider>

                    </AuthProvider>

                </ErrorBoundary>

            </BrowserRouter>
        </Provider>
    );
};


export default Root;
